import { tosDate } from "./tos.constant";

export default function Privacy() {
  return (
    <div>
      <h1>Privacy Policy</h1>
      <p>
        <strong>Effective Date:</strong> {tosDate}
      </p>

      <h2>Introduction</h2>
      <p>
        LIBERTY CONNECT, LLC values your privacy and is committed to protecting
        the personal information that you share with us. This Privacy Policy
        explains how we collect, use, and protect your personal information when
        you visit our website http://www.libertyconnect.nyc (the “Site”) and
        interact with our services. By using the Site, you consent to the
        practices described in this policy.
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        We may collect the following types of information when you visit our
        Site:
      </p>
      <ul>
        <li>
          <strong>Personal Information:</strong> Includes your name, email
          address, phone number, billing address, and payment information.
        </li>
        <li>
          <strong>Non-Personal Information:</strong> Includes IP addresses,
          browser types, and website usage data (e.g., pages visited, time spent
          on the site).
        </li>
        <li>
          <strong>Cookies and Tracking Technologies:</strong> We may use
          cookies, web beacons, and other tracking technologies to enhance your
          experience.
        </li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>We may use the information we collect for the following purposes:</p>
      <ul>
        <li>To provide and improve our services</li>
        <li>
          To communicate with you (e.g., customer support, marketing,
          newsletters)
        </li>
        <li>To process transactions and fulfill orders</li>
        <li>
          To analyze and understand how our website is used, and to enhance your
          experience
        </li>
        <li>To comply with legal obligations</li>
      </ul>

      <h2>3. Sharing Your Information</h2>
      <p>
        We do not sell, rent, or trade your personal information to third
        parties. However, we may share your information with:
      </p>
      <ul>
        <li>
          <strong>Service Providers:</strong> Third-party vendors who assist
          with business operations (e.g., payment processing, hosting,
          marketing).
        </li>
        <li>
          <strong>Legal Requirements:</strong> We may disclose your information
          if required by law.
        </li>
        <li>
          <strong>Business Transfers:</strong> In case of a merger, acquisition,
          or sale of our business assets.
        </li>
      </ul>

      <h2>4. Data Security</h2>
      <p>
        We take reasonable measures to protect your personal information from
        unauthorized access, disclosure, or destruction. However, no data
        transmission over the internet is 100% secure.
      </p>

      <h2>5. Your Rights and Choices</h2>
      <p>You have the right to:</p>
      <ul>
        <li>
          <strong>Access:</strong> Request access to your personal information.
        </li>
        <li>
          <strong>Correct:</strong> Update or correct inaccurate information.
        </li>
        <li>
          <strong>Delete:</strong> Request deletion of your personal
          information, subject to legal exceptions.
        </li>
        <li>
          <strong>Opt-out:</strong> Unsubscribe from marketing communications.
        </li>
      </ul>
      <p>
        If you are a resident of New York, you have additional rights under the
        New York SHIELD Act.
      </p>

      <h2>6. Third-Party Links</h2>
      <p>
        Our Site may contain links to third-party websites. We are not
        responsible for their privacy practices and encourage you to review
        their privacy policies.
      </p>

      <h2>7. Children&apos;s Privacy</h2>
      <p>
        Our Site is not intended for users under 18, and we do not knowingly
        collect personal information from them.
      </p>

      <h2>8. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy periodically. The updated policy will
        be posted on this page with the revised “Effective Date.”
      </p>

      <h2>9. Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy, please
        contact us at:
      </p>
      <p>
        Liberty Connect, LLC
        <br />
        42-40 Bell Blvd Ste 400, Bayside, NY 11361
        <br />
        info@libertyconnect.nyc
      </p>
    </div>
  );
}
